import dayjs from "dayjs"

import { DATE_FORMAT, EMPTY_DATE_PLACEHOLDER } from "@/constants/formats"

export const formatDate = (date?: string | null, format?: string): string =>
  dayjs(date).isValid() ? dayjs(date).format(format || DATE_FORMAT.US) : EMPTY_DATE_PLACEHOLDER

export function formatMaskedDate(valueToFormat: string, maskToUse: string): string {
  const MASK_USER_INPUT_SYMBOL = "_"
  const ACCEPT_REGEX = /\d/g
  let outputCharIndex = 0

  return valueToFormat
    .split("")
    .map((character, characterIndex) => {
      ACCEPT_REGEX.lastIndex = 0

      if (outputCharIndex > maskToUse.length - 1) {
        return ""
      }

      const maskChar = maskToUse[outputCharIndex]
      const nextMaskChar = maskToUse[outputCharIndex + 1]

      const acceptedChar = ACCEPT_REGEX.test(character) ? character : ""
      const formattedChar = maskChar === MASK_USER_INPUT_SYMBOL ? acceptedChar : maskChar + acceptedChar

      outputCharIndex += formattedChar.length

      const isLastCharacter = characterIndex === valueToFormat.length - 1
      if (isLastCharacter && nextMaskChar && nextMaskChar !== MASK_USER_INPUT_SYMBOL) {
        // when cursor at the end of mask part (e.g. month) prerender next symbol "21" -> "21/"
        return formattedChar ? formattedChar + nextMaskChar : ""
      }

      return formattedChar
    })
    .join("")
}
